// extracted by mini-css-extract-plugin
export default {"tooltip":"KP-z","arrow":"LP-z"};